import { bigIntToLong } from '#common/util';
import { KeyRangeLockingRequestMsg, ServiceBaseProto, UnlockMsg } from '#websocket/client/proto';
import { LockResponse } from './response';
import { KEY_RANGE_LOCKING_REQUEST_TYPE } from './types';
export class UnlockByNodeIdRequest {
    nodeId;
    destination;
    constructor(nodeId, destination) {
        this.nodeId = nodeId;
        this.destination = destination;
    }
    createMessage(requestId, version) {
        const unlockMessage = UnlockMsg.create({
            nodeId: this.nodeId,
        });
        const unlockRequest = KeyRangeLockingRequestMsg.create({
            type: KeyRangeLockingRequestMsg.RequestType.UNLOCK,
            unlock: unlockMessage,
        });
        return ServiceBaseProto.RequestMsg.create({
            id: bigIntToLong(requestId),
            versionMajor: version.major,
            versionMinor: version.minor,
            versionBuild: version.build,
            [KEY_RANGE_LOCKING_REQUEST_TYPE]: unlockRequest,
        });
    }
    createResponse(responseMessage) {
        return new LockResponse(responseMessage);
    }
    getDestination() {
        return this.destination;
    }
}
